import { useI18n } from 'vue-i18n';
import { createFetcher } from '@composables/createFetcher';

export type PostGetPayload = {
  id?: string;
  postCollectionId?: string;
  includeContent?: string;
};

export const usePostFetcher = () => {
  const { t } = useI18n();

  const oneFetcher = createFetcher<PostGetPayload>({
    endpoint: '/post',
    method: 'GET',
    requiresAuth: true,
    requiresArtistId: true,
    payloadAsQuery: true,
    validatePayload: (payload) => {
      if (!payload.id) {
        oneFetcher.error.value = t('errors.couldNotLoadPost');
        return false;
      }
      return true;
    },
  });

  const listFetcher = createFetcher<PostGetPayload>({
    endpoint: '/post/list',
    method: 'GET',
    requiresAuth: true,
    requiresArtistId: true,
    payloadAsQuery: true,
  });

  return {
    one: {
      ...oneFetcher,
      resetOne: () => {
        oneFetcher.data.value = null;
        oneFetcher.error.value = null;
      },
    },
    list: {
      ...listFetcher,
      resetList: () => {
        listFetcher.data.value = null;
        listFetcher.error.value = null;
      },
    },
  };
};
